import http from "../api/http";
import getLoadedConfig from "../appConfigService";

interface IWarranty {
  serialNumber: string,
  productType: string,
  firstUseDate: string,
  userReference: string,
  recordId: string,
  recordStatus: string,
  recordStatusValue: number,
  recordCreated: string,
  recordLastUpdated: string
}

interface IRVGRespeonse {
  /* RVG warranty */
  warranty: IWarranty,

  /*  true if warranty is associated to an RVG which is own by an entreprise/fleet of RVG
      false if the RVG is own by user/simple dentist
  */
  entreprise: boolean
}


export const getRVGWarrantyBySerialNumber = async (
    serialNumber: string
  ): Promise<IRVGRespeonse> => {
      const config = getLoadedConfig();
      const url = config.oDataUrl + `RVGWarranty?serialNumber=${serialNumber}`
      const resp = await http.get(url)

      return resp.data
};

export const registerRVGWarrantyBySerialNumber = async (
    serialNumber: string, userReference: string, acceptConsent: boolean
  ): Promise<IWarranty> => {
      const config = getLoadedConfig();
      const url = config.oDataUrl + `RVGWarranty(${serialNumber})`
      const resp = await http.put(url,
        {
            userReference: userReference,
            commercialInformationAck: acceptConsent
        })

      return resp.data[0]
};